import * as React from 'react';

const Phone = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={22} height={22} {...props}>
        <g fill="none" fillRule="evenodd">
            <path fill="#FFF" d="M-1337-1139H583v4595h-1920z" />
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.25}
                d="M1.076 7.875 2.28 9.08a3.343 3.343 0 0 0 4.728 0l1.773-1.773a1.67 1.67 0 0 0 0-2.364L5.334 1.496a1.674 1.674 0 0 0-2.521.164c-3.61 4.906-1.425 10.074 3.015 14.512 4.44 4.44 9.606 6.626 14.512 3.015a1.674 1.674 0 0 0 .164-2.521l-3.447-3.448a1.67 1.67 0 0 0-2.364 0L12.92 14.99a3.343 3.343 0 0 0 0 4.728l1.219 1.22"
            />
        </g>
    </svg>
);
export default Phone;
